<template>
	<header v-if="auth">
		<nav class="top-nav clearfix">
			<h1 class="brand">
				<router-link to="/main"><a v-bind:style="{'background-image': backgroundImage}">{{title}}</a></router-link>
			</h1>
			<!-- 상단메뉴 (기본상태) -->
			<ul class="gnb clearfix" v-if="!sysmenu">
				<li v-if="auth['관리자 메뉴']['회원관리']&&auth['관리자 메뉴']['회원관리'].enabled"><router-link to="/users">계정관리</router-link></li>
				<li v-if="auth['관리자 메뉴']['수강관리']&&auth['관리자 메뉴']['수강관리'].enabled"><router-link to="/classes/apply">프로그램 관리</router-link></li>
				<li v-if="auth['관리자 메뉴']['상담관리']&&auth['관리자 메뉴']['상담관리'].enabled"><router-link to="/counsel">상담관리</router-link></li>
				<li v-if="auth['관리자 메뉴']['게시판관리']&&auth['관리자 메뉴']['게시판관리'].enabled"><router-link to="/board">게시판관리</router-link></li>
				<li v-if="auth['관리자 메뉴']['통계관리']&&auth['관리자 메뉴']['통계관리'].enabled"><a href="https://analytics.google.com/analytics/web" target="_blank">통계 분석</a></li>
				<!-- <li><a class="btn-sm round f-14" @click="modals.ModalNewClass.show = true;">프로그램 등록</a></li>	-->
			</ul>
			<ul class="info-gnb clearfix" v-if="!sysmenu">
				<li class="mypage">
					<a @click="logout">로그아웃</a>
				</li>
				<!--
				<li class="msg">
					<a @click="msgPreviewOpened=!msgPreviewOpened">메세지</a>
					{{this.msgCount}}

					<div v-if="msgPreviewOpened" style="position:absolute;z-index:99999;width:300px;height:400px;overflow-y:scroll;border:1px solid #000;background-color:#fff;transform:translateX(-300px)">
						<ul>
							<li v-for="(item,idx) in msgList" :item="item" :index="idx" :key="'msg-list-'+idx+'-'+item.notificationId" style="float:none;margin-left:0;line-height:1.4;">
								<a class="notelink" style="width:100%;height:auto;background:none;text-indent:0;padding:15px;box-sizing:border-box" @click="msgRead(item)">
									{{item.readDate?'':'(새 쪽지)'}} {{item.sendMberId}}님이 발송:<br>
									{{item.content}}
								</a>
							</li>
						</ul>
					</div>
				</li>
				-->
				<li class="config">
					<a @click="sysmenu=true">설정</a>
				</li>
			</ul>

			<!-- 상단메뉴 (펼침상태) -->
			<ul class="gnb clearfix" v-if="sysmenu">
				<li v-if="auth['관리자 메뉴']['사이트 관리']&&auth['관리자 메뉴']['사이트 관리'].enabled">
					<router-link to="/site">사이트 관리</router-link>
					<ul class="gnb2">
						<li v-if="auth['관리자 메뉴']['사이트 관리']['사이트항목 목록']&&auth['관리자 메뉴']['사이트 관리']['사이트항목 목록'].enabled"><router-link to="/site">사이트항목 목록</router-link></li>
						<li v-if="auth['관리자 메뉴']['사이트 관리']['로그 관리']&&auth['관리자 메뉴']['사이트 관리']['로그 관리'].enabled"><router-link to="/log">로그 관리</router-link></li>
					</ul>
				</li>
				<li v-if="auth['관리자 메뉴']['메뉴 관리']&&auth['관리자 메뉴']['메뉴 관리'].enabled">
					<router-link to="/menu">메뉴 관리</router-link>
				</li>
				<li v-if="auth['관리자 메뉴']['교육 관리']&&auth['관리자 메뉴']['교육 관리'].enabled">
					<router-link to="/categories">교육 관리</router-link>
					<ul class="gnb2">
						<li v-if="auth['관리자 메뉴']['교육 관리']['강좌 분류']&&auth['관리자 메뉴']['교육 관리']['강좌 분류'].enabled"><router-link to="/categories">강좌 분류</router-link></li>
						<!-- <li v-if="auth['관리자 메뉴']['교육 관리']['강좌개설 초기값']&&auth['관리자 메뉴']['교육 관리']['강좌개설 초기값'].enabled"><router-link to="/default">프로그램 개설 초기값</router-link></li> -->
						<!--<li><a>설문 초기값</a></li>-->
						<!--<li><router-link to="/guides/edu">교육안내 설정</router-link></li>-->
						<!-- <li v-if="auth['관리자 메뉴']['교육 관리']['신청안내 설정']&&auth['관리자 메뉴']['교육 관리']['신청안내 설정'].enabled"><router-link to="/guides/apply">신청안내 설정</router-link></li> -->
					</ul>
				</li>
				<!-- <li v-if="auth['관리자 메뉴']['전자우편 관리']&&auth['관리자 메뉴']['전자우편 관리'].enabled">
					<router-link to="/email/forms">전자우편 관리</router-link>
					<ul class="gnb2">
						<li v-if="auth['관리자 메뉴']['전자우편 관리']['전자우편 양식 관리']&&auth['관리자 메뉴']['전자우편 관리']['전자우편 양식 관리'].enabled"><router-link to="/email/forms">전자우편 양식 관리</router-link></li>
						<li><a>자동보내기 설정</a></li>
						<li v-if="auth['관리자 메뉴']['전자우편 관리']['보낸 우편함']&&auth['관리자 메뉴']['전자우편 관리']['보낸 우편함'].enabled"><router-link to="/email/sents">보낸 우편함</router-link></li>
					</ul>
				</li> -->
				<li v-if="auth['관리자 메뉴']['문자 관리']&&auth['관리자 메뉴']['문자 관리'].enabled">
					<router-link to="/sms/forms">문자 관리</router-link>
					<ul class="gnb2">
						<li v-if="auth['관리자 메뉴']['문자 관리']['문자 양식 관리']&&auth['관리자 메뉴']['문자 관리']['문자 양식 관리'].enabled"><router-link to="/sms/forms">문자 양식 관리</router-link></li>
						<!--<li><a>자동보내기 설정</a></li>-->
						<li v-if="auth['관리자 메뉴']['문자 관리']['보낸 문자함']&&auth['관리자 메뉴']['문자 관리']['보낸 문자함'].enabled"><router-link to="/sms/sents">보낸 문자함</router-link></li>
					</ul>
				</li>
				<li v-if="auth['관리자 메뉴']['설문 관리']&&auth['관리자 메뉴']['설문 관리'].enabled">
					<router-link to="/surveys">설문 관리</router-link>
					<ul class="gnb2">
						<li v-if="auth['관리자 메뉴']['설문 관리']['설문 관리']&&auth['관리자 메뉴']['설문 관리']['설문 관리'].enabled"><router-link to="/surveys">설문 관리</router-link></li>
						<li v-if="auth['관리자 메뉴']['설문 관리']['설문문항 관리']&&auth['관리자 메뉴']['설문 관리']['설문문항 관리'].enabled"><router-link to="/surveyItems">설문문항 관리</router-link></li>
						<!--<li><router-link to="/surveys/default">과정별 설문 초기값</router-link></li>-->
						<li v-if="auth['관리자 메뉴']['설문 관리']['설문 분류']&&auth['관리자 메뉴']['설문 관리']['설문 분류'].enabled"><router-link to="/surveys/categories">설문 분류</router-link></li>
						<li v-if="auth['관리자 메뉴']['설문 관리']['설문 통계']&&auth['관리자 메뉴']['설문 관리']['설문 통계'].enabled"><router-link to="/surveys/statistics">설문 통계</router-link></li>
					</ul>
				</li>
				<!--
				<li v-if="auth['관리자 메뉴']['시험 관리']&&auth['관리자 메뉴']['시험 관리'].enabled">
					<router-link to="/exams">시험 관리</router-link>
					<ul class="gnb2">
						<li v-if="auth['관리자 메뉴']['시험 관리']['시험문항 관리']&&auth['관리자 메뉴']['시험 관리']['시험문항 관리'].enabled"><router-link to="/exams">시험문항 관리</router-link></li>
						<li v-if="auth['관리자 메뉴']['시험 관리']['시험 분류']&&auth['관리자 메뉴']['시험 관리']['시험 분류'].enabled"><router-link to="/exams/categories">시험 분류</router-link></li>
					</ul>
				</li>
				<li v-if="auth['관리자 메뉴']['강의지원']&&auth['관리자 메뉴']['강의지원'].enabled">
					<router-link to="/institutions">강의지원</router-link>
					<ul class="gnb2">
						<li v-if="auth['관리자 메뉴']['강의지원']['소속기관 관리']&&auth['관리자 메뉴']['강의지원']['소속기관 관리'].enabled"><router-link to="/institutions">소속기관 관리</router-link></li>
					</ul>
				</li>
				<li v-if="auth['관리자 메뉴']['권한 관리']&&auth['관리자 메뉴']['권한 관리'].enabled">
					<router-link to="/permissions">권한 관리</router-link>
					<ul class="gnb2">
						<li v-if="auth['관리자 메뉴']['권한 관리']['권한 관리']&&auth['관리자 메뉴']['권한 관리']['권한 관리'].enabled"><router-link to="/permissions">권한 관리</router-link></li>
						<li v-if="auth['관리자 메뉴']['권한 관리']['권한 편집']&&auth['관리자 메뉴']['권한 관리']['권한 편집'].enabled"><router-link to="/permissions/list">권한 편집</router-link></li>
					</ul>
				</li>
				-->
				<li v-if="auth['관리자 메뉴']['팝업 관리']&&auth['관리자 메뉴']['팝업 관리'].enabled">
					<router-link to="/popup">팝업 관리</router-link>
					<ul class="gnb2">
						<li v-if="auth['관리자 메뉴']['팝업 관리']['누리집 팝업 관리']&&auth['관리자 메뉴']['팝업 관리']['누리집 팝업 관리'].enabled"><router-link to="/popup">누리집 팝업 관리</router-link></li>
					</ul>
				</li>
				<!--
				<li>
					<a>시스템 관리</a>
					<ul class="gnb2">
						<li><a>로그조회</a></li>
						<li><a>코드관리</a></li>
						<li><router-link to="/filters">목록 필터 관리</router-link></li>
					</ul>
				</li>
				<li><a>통계</a></li>
				-->
			</ul>
			<ul class="info-gnb clearfix" v-if="sysmenu">
				<li>
					<a class="btn-sm round" @click="sysmenu=false">
						<img src="images/off-setting.png" alt="" width="15"> 닫기
					</a>
				</li>
			</ul>
		</nav>
		<nav class="bottom-nav clearfix">
			<div class="inner">
				<slot>
					<h2 class="page-tit" style="margin-top: -15px;">
						<small class="text-white" v-if="subname">{{ subname }}</small>
						{{ name }}
					</h2>
				</slot>
				<div class="search-box" style="margin-top: -25px;" v-if="searchbox">
					<input id="search" class="form-control full-width m-b-0" type="text" ref="searchKeyword" v-model="searchKeyword"  @keyup.enter="emitSearchKeywordChanged()">
					<label for="search" @click="emitSearchKeywordChanged()">검색</label>
				</div>
				<ul class="sub-gnb clearfix">
					<li v-for="menu in menus" v-bind:class="{on:menu.selected}" v-bind:key="menu.name"><router-link :to="menu.link">{{ menu.name }}</router-link></li>
				</ul>
				<div class="page-btn-box">
					<button v-for="button in buttons" v-on:click="button.fn" v-bind:key="button.name" class="btn round" type="button">{{ button.name }}</button>
				</div>
			</div>
		</nav>

		<modal-new-class :config="modals.ModalNewClass" @close="modals.ModalNewClass.show=false" :key="'modal-new-class-'+hash(modals.ModalNewClass)"></modal-new-class>
		<modal-alert :config="modals.ModalAlert" @close="modals.ModalAlert.show=false;" :key="hash(modals.ModalAlert)"></modal-alert>
	</header>
</template>

<script>
import ModalNewClass from '../modals/ModalNewClass.vue'
import ModalAlert from '../modals/ModalAlert.vue'
import cookie from 'js-cookie'
import axios from 'axios'
import server from '../statics/server.js'
import moment from 'moment'

export default {
	// 컴포넌트 명
	name: "CommonHeader",
	components: {
		ModalNewClass,
		ModalAlert
	},
	mounted: function() {
		this.getLoginInfo().then((response) => {
			let auth = {"관리자 권한":[], "강사 권한":[], "CMS 권한":[], "관리자 메뉴":{}};
			response.data.return.authAllotList.forEach( (authRecord) => {
				let temp = JSON.parse(authRecord.authJson);
				if(temp["관리자 권한"]) temp["관리자 권한"].forEach((a) => {
					if(a.permission) {
						if(!auth["관리자 권한"].find(e=>e.name==a.name)) {
							auth["관리자 권한"].push({...a});
						}
					}
				})
				if(temp["강사 권한"]) temp["강사 권한"].forEach((a) => {
					if(a.permission) {
						if(!auth["강사 권한"].find(e=>e.name==a.name)) {
							auth["강사 권한"].push({...a});
						}
					}
				})
				if(temp["CMS 권한"]) temp["CMS 권한"].forEach((a) => {
					if(a.permission) {
						if(!auth["CMS 권한"].find(e=>e.name==a.name)) {
							auth["CMS 권한"].push({...a});
						}
					}
				})
				if(temp["관리자 메뉴"]) Object.keys(temp["관리자 메뉴"]).forEach((k) => {
					if(!auth["관리자 메뉴"][k]) auth["관리자 메뉴"][k] = {};
					if(temp["관리자 메뉴"][k].enabled) {
						auth["관리자 메뉴"][k].enabled = true;
						Object.keys(temp["관리자 메뉴"][k]).forEach((ck) => {
							if(ck=="enabled") return;
							if(!auth["관리자 메뉴"][k][ck]) auth["관리자 메뉴"][k][ck] = {};
							if(temp["관리자 메뉴"][k][ck].enabled)
								auth["관리자 메뉴"][k][ck].enabled = true;
						})
					}
				})
			});
			this.auth = auth;
			return response.data.return;
		}).then((mber) => {
			mber;
			// 쪽지조회 루프 시작
			/*setInterval( (function(){
				axios.post(server.addr()+server.api.NOTIFICATION, {mberId:"관리자",orderBy:"REG_DATE DESC"}).then(response => {
					this.msgList = response.data.list;
					this.msgCount = this.msgList.filter(e=>!e.readDate).length;
				});
			}).bind(this), 3000);*/
		}).catch( () => {
			this.modals.ModalAlert.msg = "로그인해야 합니다.";
			this.modals.ModalAlert.btn.fn = ()=>{this.log();}
			this.modals.ModalAlert.show = true;
		})
	},

	// 이 컴포넌트 내부에서 사용되는 데이터
	data: function() {
		return {
			msgCount: 0,
			msgPreviewOpened: false,
			msgList: [],
			title: server.logo.title,
			backgroundImage: server.logo.img,

			searchKeyword: this.initKeyword || "",
			sysmenu: this.mainmenuOpened,
			auth: null,
			modals: {
				ModalNewClass: ModalNewClass.default(),
				ModalAlert: ModalAlert.default(),
			},
		}
	},

	// 부모컴포넌트로부터 전달받는 프로퍼티
	props: {
		name: String,
		subname: String,
		menus: Array,
		buttons: Array,
		mainmenuOpened :Boolean,
		searchbox: Boolean,
		initKeyword: String
	},

	// 이 컴포넌트에서 사용되는 기능
	methods: {
		emitSearchKeywordChanged: function(){
			this.$emit("keywordChanged", this.searchKeyword)
		},
		logout: function() {
			cookie.set("access_token", "");
			this.$router.push("/");
		},
		msgRead: function(item) {
			axios.patch(server.addr()+server.api.NOTIFICATION+"/"+item.notificationId, {readDate:moment().format("YYYY-MM-DD HH:mm:SS")}).then(() => {})
		}
	}
}
</script>

<style scoped>
.bottom-nav { overflow: hidden; }
a.notelink:hover { background-color:#efefef !important; color:#333 !important; }
</style>